import { Trade, CallPut } from './types';
import {
  calculateOptionFlowAggregate,
  type OptionFlowAggregateOptions,
} from './aggregateOptionFlow';
import { normalizeCallPut } from './normalizeCallPut';
import { getDefaultFlowSideBasisSelection } from './presets';

export const getVolumePutFlow = (trades: Trade[]) => {
  let puts = 0;
  let calls = 0;

  trades.forEach((trade) => {
    const cp = normalizeCallPut(trade.cp);

    if (cp === CallPut.Put) {
      puts += trade.size || 0;
    }
    if (cp === CallPut.Call) {
      calls += trade.size || 0;
    }
  });

  if (calls + puts === 0) {
    return 0;
  }

  return puts / (calls + puts);
};

export const getPremiumPutFlow = (trades: Trade[]) => {
  let puts = 0;
  let calls = 0;

  trades.forEach((trade) => {
    const cp = normalizeCallPut(trade.cp);

    if (cp === CallPut.Put) {
      puts += trade.premium;
    }
    if (cp === CallPut.Call) {
      calls += trade.premium;
    }
  });

  if (calls + puts === 0) {
    return 0;
  }

  return puts / (calls + puts);
};

export const calculatePutFlow = (trades: Trade[], options: OptionFlowAggregateOptions = {}) => {
  const {
    putFlow,
    putCallRatio,
    putFlowPremium,
    putFlowVolume,
    putVolume,
    callVolume,
    putPremium,
    callPremium,
  } = calculateOptionFlowAggregate(trades, {
    flowSideBasis: options.flowSideBasis || getDefaultFlowSideBasisSelection(),
    putFlowBasis: options.putFlowBasis || 'premium',
  });

  return {
    putFlow,
    putCallRatio,
    putFlowPremium,
    putFlowVolume,
    putVolume,
    callVolume,
    putPremium,
    callPremium,
  };
};
